import { Color, ComponentsGroup, DefaultValue, Divider, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const CustomTooltipWrapper = styled.div`
  width: 216px;
  height: 164px;
  padding: ${Spacing.S16};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
  ${getShadow('elevatedLight')};
`

export const TooltipComponentsGroup = styled(ComponentsGroup)`
  justify-content: space-between;
  margin-top: ${Spacing.S8};
`

export const TooltipDivider = styled(Divider)`
  margin-top: ${Spacing.S8};
`

export const TooltipData = styled.div``
